import axios from "axios";

export function apiGetPersonnes(instance, queryParams) {
  return axios
    .get(
      process.env.REACT_APP_URL_EXPRESS + "api/personnes" + (queryParams ? "?" + queryParams : ""),
      {
        headers: {
          instance: instance,
        },
      }
    )
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
}

export function apiGetPersonne(instance, id, queryParams) {
  return axios
    .get(
      process.env.REACT_APP_URL_EXPRESS +
        "api/personnes/" +
        id +
        (queryParams ? "?" + queryParams : ""),
      {
        headers: {
          instance: instance,
        },
      }
    )
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
}

export function apiSavePersonne(instance, formData) {
  return axios
    .post(process.env.REACT_APP_URL_EXPRESS + "api/personnes", formData, {
      headers: {
        instance: instance,
        "Content-Type": "multipart/form-data",
      },
    })
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
}

export function apiUpdatePersonne(id, formData) {
  return axios
    .put(process.env.REACT_APP_URL_EXPRESS + "api/personnes/" + id, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
}

export function apiDeletePersonne(id) {
  return axios
    .delete(process.env.REACT_APP_URL_EXPRESS + "api/personnes/" + id)
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
}

export function apiExportPersonnes(instance, queryParams) {
  return axios
    .get(
      process.env.REACT_APP_URL_EXPRESS +
        "api/personnes/export" +
        (queryParams ? "?" + queryParams : ""),
      {
        responseType: "arraybuffer",
        headers: {
          instance: instance,
        },
      }
    )
    .then(function (response) {
      const blob = new Blob([response.data], { type: "text/csv;charset=utf-8" });
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = "exportCollaborateursEasyGouv.csv";
      link.click();
    })
    .catch(function (error) {
      return error.response;
    });
}
